import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import {
  assignAta,
  assignObiToBox,
  commitRearrangedEPIs,
  getEpikBoxData,
  updateAllEpisFirmware,
} from '../../../../../actions/EpikBoxes';
import GrandStream from '../../../../../containers/GrandStream/GrandStream';
import CustomModal from '../../../../CustomModal';
import BoxObi from './BoxObi';
import DraggableBoxObi from './DraggableBoxObi';
import './EpikBoxObis.css';
import ExternalAta from './ExternalAta';
import RearrangeEPIControls from './RearrangeEPIControls';
import RearrangePorts from '../../../../../containers/RearrangePorts/RearrangePorts';
import logoLoading from '../../../../../Res/logo-loading.gif';
import { getObiSystemStatus } from '../../../../../actions/EpikBoxes';
import { createPortal } from 'react-dom';
import ConfirmationModal from '../../../../ConfirmationModal';
import firmwareUpgrade from '../../../../../Res/svg/epi-update.svg';
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import utils from '../../../../../lib/utils';

const EpikboxObi = props => {
  const token = localStorage.getItem('jwtToken') || null;
  const [isOpen, setIsOpen] = useState(false);
  const [openArrange, setOpenArrange] = useState(false);
  const [showUrl, setShowUrl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [newRearrangeList, setNewRearrangeList] = useState([]);
  const [arrangeLoading, setArrangeLoading] = useState(false);
  const dispatch = useDispatch();
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const [loading, setLoading] = useState(false);
  const [boxObisDetails, setBoxObisDetails] = useState([]);
  const [loadingObis, setLoadingObis] = useState(false);
  const [epiUpdateModal, setEpiUpdateModal] = useState(false);

  const {
    obis,
    openUnassignedObis,
    showBoxConfig,
    onSelect,
    selected,
    onSetRearrange,
    onCancelRearrange,
    rearrangeState,
    rearrangedEpis,
    updateEPIs,
    onBoxEpiDelete,
    enableBoxEdit,
    obiReboot,
    box,
    user,
  } = props;
  const isAllEscene = useMemo(() => {
    return obis.some(obi => obi?.macAddress?.startsWith('0026'));
  }, [obis]);

  const timer = useMemo(() => {
    return utils.calculateEpiFirmwareUpdateTimer(boxDetails?.epiFirmwareUpdateTimer);
  }, [boxDetails?.epiFirmwareUpdateTimer]);

  const moveEpi = useCallback(
    (dragIndex, hoverIndex) => {
      const updatedEPIs = move(rearrangedEpis, dragIndex, hoverIndex);
      onSetRearrange(updatedEPIs);
    },
    [rearrangedEpis],
  );

  //get data from obis
  useEffect(() => {
    async function fetchData() {
      setLoadingObis(true);
      const promises = obis?.map(async obi => {
        const portName = obi.port1?.boxPortNumber?.split(' ');
        try {
          if (portName) {
            const res = await dispatch(getObiSystemStatus(token, boxDetails._id, portName[1]));
            return { ...res, obi };
          } else {
            return { obi };
          }
        } catch (error) {
          // Handle errors if necessary
          console.error('Error fetching data for obi', obi, error);
          return null;
        }
      });

      if (promises && promises.length) {
        const allObisResult = await Promise.all(promises);
        const filteredObis = allObisResult.filter(result => result !== null);
        setBoxObisDetails(filteredObis);
      }

      setLoadingObis(false);
    }

    fetchData();
  }, [obis, token, boxDetails]);

  if (!obis.length) {
    return (
      <div className="noObiContainer">
        <div className="message">No OBIs configured on Edge Device.</div>
        <div className="addObi">
          <Button
            disabled={user.readOnly}
            onClick={ev => {
              ev.stopPropagation();
              openUnassignedObis();
            }}
            type="primary"
          >
            Assign EPI
          </Button>
        </div>
      </div>
    );
  }

  const move = (arr, from, to) => {
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    return clone;
  };

  const onConfirm = async () => {
    setLoading(true);
    const body = {
      companyID: box.assignedTo._id,
      deviceMacAddress: selectedData.macAdress,
      numberOfPorts: selectedData.ports,
    };
    const result = await dispatch(assignAta(token, body, box._id));
    if (result) {
      setShowUrl({ url: result?.info?.provisioningUrl, macAddress: result?.macAddress });
      props.boxTrigger(true);
    }
    setLoading(false);
  };
  const selectedItems = (macAdress, ports) => {
    setSelectedData({ macAdress, ports });
  };

  const unassignBoxTrigger = () => {
    // eslint-disable-next-line react/destructuring-assignment
    props.boxTrigger(true);
  };

  const newObiArrangement = list => {
    setNewRearrangeList(list);
  };

  const onRearrange = async () => {
    const { getBoxData } = props;
    const sortedWithNew = newRearrangeList.sort((a, b) => a.newPort - b.newPort);
    const obisWithNew = sortedWithNew.reduce((acc, obi) => {
      const obiObj = obis[obi.currentPort];
      return [...acc, obiObj];
    }, []);
    setArrangeLoading(true);
    await dispatch(commitRearrangedEPIs(token, obisWithNew, boxDetails));
    setOpenArrange(false);
    setArrangeLoading(false);
    getBoxData();
  };
  const updateEpiFirmware = async () => {
    setEpiUpdateModal(false);
    await dispatch(updateAllEpisFirmware(token, boxDetails._id));
    await dispatch(getEpikBoxData(token, boxDetails._id));
  };
  const renderModal = () => {
    if (epiUpdateModal) {
      return createPortal(
        <ConfirmationModal
          isOpen={epiUpdateModal}
          onCancel={() => {
            setEpiUpdateModal(false);
          }}
          headerText={`EPI Firmware Update`}
          bodyText={`This process will take approximately 15 minutes to complete and require the ports on this device to reboot. Would you like to proceed with this update now?`}
          onConfirm={updateEpiFirmware}
        />,
        document.body, // Render the modal outside the component's DOM hierarchy
      );
    }
  };
  console.log({ isAllEscene });
  return loadingObis || boxObisDetails.length === 0 ? (
    <div className="error-msg d-flex flex-column justify-content-center align-items-center">
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
      <p className="text-align-center">Loading, Please wait...</p>
    </div>
  ) : (
    <div className="obisContainer">
      <BoxObi
        obiReboot={obiReboot}
        enableBoxEdit={enableBoxEdit}
        selected={selected}
        onBoxEpiDelete={onBoxEpiDelete}
        onObiSelect={onSelect}
        boxObisDetails={boxObisDetails}
      />
      {box?.externalAta?.length ? <ExternalAta boxTrigger={unassignBoxTrigger} box={box} /> : null}
      <div className="epiFooter margin-epi">
        <div>
          <Button
            disabled={!enableBoxEdit || user.readOnly}
            color="primary"
            style={{ width: 'auto' }}
            onClick={ev => {
              ev.stopPropagation();
              openUnassignedObis();
            }}
          >
            Assign EPI
          </Button>
          <Button color="primary" style={{ width: 'auto' }} onClick={() => setIsOpen(true)}>
            Add External Ports
          </Button>
          <Button color="primary" style={{ width: 'auto' }} onClick={() => setOpenArrange(true)}>
            Rearrange Ports
          </Button>
          <Button
            hidden={!box.inhouseProvision}
            disabled={!enableBoxEdit}
            color="primary"
            style={{ width: 'auto' }}
            onClick={ev => {
              ev.stopPropagation();
              showBoxConfig();
            }}
          >
            Advanced EPI Configuration
          </Button>
          {isAllEscene && timer && (
            <>
              {/* <div style={{ pointerEvents: user.readOnly ? 'none' : 'auto', }}>
                <TooltipIcon
                  tipId={`updateAllEpi`}
                  onClick={() => setEpiUpdateModal(true)}
                  imgSrc={firmwareUpgrade}
                  displayData="Hard Firmware Update"
                  placement="top"
                  customClass="epi-info"
                  customStyle={{
                    position: 'relative',
                    top: '3px',
                    height: '30px',
                  }}
                />
              </div> */}
              <Button
                hidden={!box.inhouseProvision}
                disabled={!enableBoxEdit}
                color="primary"
                style={{ width: 'auto' }}
                onClick={ev => {
                  ev.stopPropagation();
                  setEpiUpdateModal(true);
                }}
              >
                Hard Firmware Update
              </Button>
            </>
          )}
        </div>
      </div>
      <CustomModal
        confirmDisabled={loading || !selectedData?.macAdress}
        header="External Port Configuration"
        onConfirm={onConfirm}
        isOpen={isOpen}
        onCancel={() => {
          setIsOpen(false);
          setShowUrl(null);
        }}
        loading={loading}
        submitDisplay={showUrl?.macAddress}
      >
        <GrandStream selectedItems={selectedItems} showUrl={showUrl} />
      </CustomModal>

      <CustomModal
        confirmDisabled={arrangeLoading || newRearrangeList?.length !== obis?.length}
        header="Rearrange Ports"
        onConfirm={onRearrange}
        isOpen={openArrange}
        onCancel={() => {
          setOpenArrange(false);
        }}
        loading={arrangeLoading}
        customButtomColor="primary"
      >
        <RearrangePorts obis={obis} newObiArrangement={newObiArrangement} />
      </CustomModal>
      {renderModal()}
    </div>
  );
};

export default EpikboxObi;
